import { useContext } from 'react';

import { WizardState, WizardContext } from '../../WizardState';

export const useWizardState = <T>() => {
  const context = useContext<WizardContext<T> | null>(WizardState);
  if (!context) {
    throw new Error('useWizardState must be used within a WizardState.Provider');
  }
  return context;
};
